import Gifto from './Gifto';
import LatiumX from './LatiumX';
import Tronix from './Tronix';
import Bear from './Bear';
import Cub from './Cub';

const Tokens = [
    Gifto,
    LatiumX,
    Tronix,
    Bear,
    Cub
];

export default Tokens;


// WEBPACK FOOTER //
// ./src/Tokens/all.js